import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link, useParams } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function CurrencyNotFound() {
  const { code } = useParams({ strict: false });
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Currency not found"
      description={
        code ? `There's no currency ${code}. It may have been deleted, or the link is out of date.` : undefined
      }
      action={
        <Button variant="outline" asChild>
          <Link to="/currencies">Back to currencies</Link>
        </Button>
      }
    />
  );
}
